<!-- 主动发货出库页面 -->
<!-- 功能说明：支持将产品通过代理商、门店或零售方式发货出库 -->
<!-- 录入方式：手动录入溯源码、批次选择、ID号段三种方式 -->
<!-- 注意：单独录入的已装箱产品码发货后将自动解除装箱绑定 -->

<!-- data 说明 -->
<!-- codeValue: 手动录入的溯源码文本（换行分隔） -->
<!-- inputMethod: 录入方式，1-手动录入 2-批次选择 3-ID号段 -->
<!-- formItem: 发货表单数据 -->
<!--   shipper_type: 发货方式，1-发货给代理商 2-发货给门店 3-零售出库 -->
<!--   store_id: 门店ID -->
<!--   agent_id: 代理商ID -->
<!--   new_agent_id: 重新关联的代理商ID -->
<!--   batch_id: 批次ID数组（多选） -->
<!--   new_batch_id: 重新关联的批次ID -->
<!--   product_id: 重新关联的产品ID -->
<!--   logistics: 物流公司名称 -->
<!--   logistics_company_id: 物流公司ID -->
<!--   logistics_number: 物流单号 -->
<!--   logistics_time: 发货时间 -->
<!--   reason: 备注说明 -->
<!--   type: 出库类型，固定为1（发货出库） -->
<!--   code: 溯源码数组 -->
<!--   start_id: ID号段起始值 -->
<!--   end_id: ID号段截止值 -->
<!-- agentList: 代理商下拉列表 -->
<!-- batchList: 批次下拉列表 -->
<!-- productList: 产品下拉列表 -->
<!-- storeList: 门店下拉列表 -->
<!-- logisticsList: 物流公司下拉列表 -->
<!-- agent_value: 是否存在代理商（控制发货方式和重新关联代理商的显隐） -->
<!-- store_value: 是否存在门店（控制发货给门店选项的显隐） -->

<!-- methods 说明 -->
<!-- getAgentSelect: 获取代理商下拉列表，有数据时显示代理商相关选项 -->
<!-- getStoreSelect: 获取门店下拉列表，有数据时显示门店相关选项 -->
<!-- getBatchSelect: 获取批次下拉列表 -->
<!-- getProductSelect: 获取产品下拉列表 -->
<!-- getIncomingSelect: 获取物流公司下拉列表 -->
<!-- changeDate: 发货时间变更处理 -->
<!-- changeLogistics: 物流公司变更处理，同步更新公司ID和名称 -->
<!-- goSubmitForm: 提交发货表单，校验ID号段后将溯源码按行分割并过滤空行，提交成功后重置表单 -->
<!-- handleInputChange: 溯源码输入处理，解析URL中的q参数值，支持混合录入溯源码、箱码和发货码 -->
<!-- 主动发货出库 -->
<template>
    <div class="container">
        <div class="header">
            <img class="w24 mr12" src="../../assets/information.png" />
            <div>
                <div>
                    单独录入的产品码如果装过箱，执行发货后，将解除装箱绑定。
                </div>
                <div>
                    (系统将视为是将箱内的产品分拆出来单独发货出库，省去了执行拆箱操作的步骤。)
                </div>
            </div>
        </div>
        <div class="content">
            <Form :model="formItem" label-position="right" :label-width="130">
                <FormItem label="发货方式：">
                    <RadioGroup v-model="formItem.shipper_type" type="button">
                        <Radio v-if="agent_value" label="1" class="mr24"
                            >发货给代理商</Radio
                        >
                        <Radio v-if="store_value" label="2" class="mr24"
                            >发货给门店</Radio
                        >
                        <Radio label="3">零售出库</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem
                    v-if="formItem.shipper_type == '1'"
                    label="选择代理商："
                >
                    <Select
                        class="w400"
                        v-model="formItem.agent_id"
                        clearable
                        filterable
                        placeholder="模糊搜索代理商名称"
                    >
                        <Option
                            v-for="item in agentList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.agent_name }}</Option
                        >
                    </Select>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon
                            class="cursor-p ml24"
                            type="md-help-circle"
                            size="20"
                            color="#FF4838"
                        />
                        <div slot="content">
                            <p class="ml12">留空则视为零售出库。</p>
                        </div>
                    </Tooltip>
                </FormItem>
                <FormItem
                    v-if="formItem.shipper_type == '2'"
                    label="选择门店："
                >
                    <Select
                        class="w400"
                        v-model="formItem.store_id"
                        clearable
                        filterable
                        placeholder="模糊搜索选择门店"
                    >
                        <Option
                            v-for="item in storeList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.name }}</Option
                        >
                    </Select>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon
                            class="cursor-p ml24"
                            type="md-help-circle"
                            size="20"
                            color="#FF4838"
                        />
                        <div slot="content">
                            <p class="ml12">留空则视为零售出库。</p>
                        </div>
                    </Tooltip>
                </FormItem>
                <FormItem label="录入方式：">
                    <RadioGroup v-model="inputMethod">
                        <Radio class="mr24" label="1">手动录入</Radio>
                        <Radio class="mr24" label="2">批次选择</Radio>
                        <Radio class="mr24" label="3">ID号段</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem v-if="inputMethod == 2" label="选择批次：">
                    <Select
                        class="w400"
                        v-model="formItem.batch_id"
                        multiple
                        clearable
                        filterable
                        placeholder="请选择"
                    >
                        <Option
                            v-for="item in batchList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.batch_name }}</Option
                        >
                    </Select>
                </FormItem>
                <FormItem v-if="inputMethod == 3" label="ID号段：">
                    <Input
                        class="w10 mr24"
                        type="number"
                        v-model="formItem.start_id"
                        placeholder="请输入起始ID"
                    ></Input>
                    <Input
                        class="w10"
                        type="number"
                        v-model="formItem.end_id"
                        placeholder="请输入截止ID"
                    ></Input>
                </FormItem>
                <FormItem label="重新关联批次：">
                    <Select
                        class="w400"
                        v-model="formItem.new_batch_id"
                        clearable
                        filterable
                        placeholder="模糊搜索批次名"
                    >
                        <Option
                            v-for="item in batchList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.batch_name }}</Option
                        >
                    </Select>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon
                            class="cursor-p ml24"
                            type="md-help-circle"
                            size="20"
                            color="#FF4838"
                        />
                        <div slot="content">
                            <p class="ml12">
                                如果关联的批次不变，请留空。
                                <span class="theme-color"
                                    >如果重新关联批次请跟产品对应修改，以免批次和产品关联对应混乱！</span
                                >
                            </p>
                        </div>
                    </Tooltip>
                </FormItem>
                <FormItem label="重新关联产品：">
                    <Select
                        class="w400"
                        v-model="formItem.product_id"
                        clearable
                        filterable
                        placeholder="模糊搜索产品名称"
                    >
                        <Option
                            v-for="item in productList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.product_name }}</Option
                        >
                    </Select>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon
                            class="cursor-p ml24"
                            type="md-help-circle"
                            size="20"
                            color="#FF4838"
                        />
                        <div slot="content">
                            <p class="ml12">
                                如果关联的产品不变，请留空。
                                <span class="theme-color"
                                    >如果重新关联产品请跟批次对应修改，以免批次和产品关联对应混乱！</span
                                >
                            </p>
                        </div>
                    </Tooltip>
                </FormItem>
                <FormItem v-if="agent_value" label="重新关联代理商：">
                    <Select
                        class="w400"
                        v-model="formItem.new_agent_id"
                        clearable
                        filterable
                        placeholder="模糊搜索代理商名称"
                    >
                        <Option
                            v-for="item in agentList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.agent_name }}</Option
                        >
                    </Select>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon
                            class="cursor-p ml24"
                            type="md-help-circle"
                            size="20"
                            color="#FF4838"
                        />
                        <div slot="content">
                            <p class="ml12">如果关联的代理商不变，请留空。</p>
                        </div>
                    </Tooltip>
                </FormItem>
                <FormItem v-if="inputMethod == 1" label="录入溯源码：">
                    <Input
                        class="w400"
                        type="textarea"
                        v-model="codeValue"
                        :autosize="{ minRows: 6 }"
                        placeholder="录入溯源码，小箱码，大箱码，发货码，一行一个，支持手动和扫码枪扫码录入"
                        @input="handleInputChange"
                    ></Input>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon
                            class="cursor-p ml24"
                            type="md-help-circle"
                            size="20"
                            color="#FF4838"
                        />
                        <div slot="content">
                            <p class="ml12">
                                支持溯源码，小箱码，大箱码，发货码混合录入。系统会智能匹配，自动批量处理。
                                <span class="theme-color"
                                    >每次发货数量不要过多，以免系统处理超时。</span
                                >
                            </p>
                        </div>
                    </Tooltip>
                </FormItem>
                <FormItem label="选择物流公司：">
                    <Select
                        class="w400"
                        v-model="formItem.logistics_company_id"
                        clearable
                        filterable
                        placeholder="选择或搜索快递或物流公司"
                        :label-in-value="true"
                        @on-change="changeLogistics"
                    >
                        <Option
                            v-for="item in logisticsList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.name }}</Option
                        >
                    </Select>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon
                            class="cursor-p ml24"
                            type="md-help-circle"
                            size="20"
                            color="#FF4838"
                        />
                        <div slot="content">
                            <p class="ml12">如果没有请留空。</p>
                        </div>
                    </Tooltip>
                </FormItem>
                <FormItem label="物流单号：">
                    <Input
                        class="w400"
                        type="text"
                        v-model="formItem.logistics_number"
                        placeholder="请输入物流单号"
                    ></Input>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon
                            class="cursor-p ml24"
                            type="md-help-circle"
                            size="20"
                            color="#FF4838"
                        />
                        <div slot="content">
                            <p class="ml12">如果没有请留空。</p>
                        </div>
                    </Tooltip>
                </FormItem>
                <FormItem label="备注说明：">
                    <Input
                        class="w400"
                        type="textarea"
                        v-model="formItem.reason"
                        :autosize="{ minRows: 6 }"
                        placeholder="填写相关备注信息，会出现在发货记录和物流记录中"
                    ></Input>
                </FormItem>
                <FormItem label="发货时间：">
                    <DatePicker
                        class="w400"
                        :value="formItem.logistics_time"
                        type="date"
                        placeholder="请选择发货时间"
                        @on-change="changeDate"
                    ></DatePicker>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon
                            class="cursor-p ml24"
                            type="md-help-circle"
                            size="20"
                            color="#FF4838"
                        />
                        <div slot="content">
                            <p class="ml12">
                                选择发货时间，不选择则默认当前时间
                            </p>
                        </div>
                    </Tooltip>
                </FormItem>
                <div class="footer">
                    <Button
                        class="theme-bc theme-default-color"
                        @click="goSubmitForm"
                        >确定</Button
                    >
                </div>
            </Form>
        </div>
    </div>
</template>

<script>
import {
    incoming_coming,
    agent_select,
    batch_select,
    product_select,
    store_select,
    incoming_select,
} from "@/api/index";
export default {
    data() {
        return {
            codeValue: "",
            inputMethod: "1",
            formItem: {
                shipper_type: "1",
                store_id: "",
                agent_id: "",
                new_agent_id: "",
                batch_id: [],
                new_batch_id: "",
                product_id: "",
                logistics: "",
                logistics_number: "",
                reason: "",
                logistics_time: "",
                type: "1",
                code: [],
                logistics_company_id: "",
                start_id: "",
                end_id: "",
            },
            agentList: [],
            batchList: [],
            productList: [],
            storeList: [],
            logisticsList: [],
            agent_value: false,
            store_value: false,
        };
    },
    mounted() {
        this.getAgentSelect();
        this.getBatchSelect();
        this.getProductSelect();
        this.getStoreSelect();
        this.getIncomingSelect();
    },
    methods: {
        getAgentSelect() {
            agent_select()
                .then((res) => {
                    this.agentList = res.data;
                    if (this.agentList.length) {
                        this.agent_value = true;
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getStoreSelect() {
            store_select()
                .then((res) => {
                    this.storeList = res.data;
                    if (this.storeList.length) {
                        this.store_value = true;
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getBatchSelect() {
            batch_select()
                .then((res) => {
                    this.batchList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getProductSelect() {
            product_select()
                .then((res) => {
                    this.productList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getIncomingSelect() {
            incoming_select()
                .then((res) => {
                    this.logisticsList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        changeDate(e) {
            if (e) {
                this.formItem.logistics_time = e;
            } else {
                this.formItem.logistics_time = "";
            }
        },
        changeLogistics(e) {
            if (e) {
                this.formItem.logistics_company_id = e.value;
                this.formItem.logistics = e.label;
            } else {
                this.formItem.logistics_company_id = "";
                this.formItem.logistics = "";
            }
        },
        // 确定（提交表单）
        goSubmitForm() {
            const startId = parseInt(this.formItem.start_id);
            const endId = parseInt(this.formItem.end_id);
            if (this.formItem.start_id && this.formItem.end_id) {
                if (
                    isNaN(startId) ||
                    isNaN(endId) ||
                    startId < 0 ||
                    endId < 0
                ) {
                    this.$Message.error("ID号段必须为正整数");
                    return;
                }
                if (startId > endId) {
                    this.$Message.error("起始ID要小于截止ID");
                    return;
                }
            }
            this.formItem.code = [];
            if (this.codeValue) {
                const codeList = this.codeValue
                    .split("\n")
                    .map((item) => item.trim())
                    .filter((item) => item !== "");
                this.formItem.code = codeList;
            }
            incoming_coming(this.formItem)
                .then((res) => {
                    this.formItem = {
                        shipper_type: "1",
                        store_id: "",
                        agent_id: "",
                        new_agent_id: "",
                        batch_id: [],
                        new_batch_id: "",
                        product_id: "",
                        logistics: "",
                        logistics_number: "",
                        reason: "",
                        logistics_time: "",
                        type: "1",
                        code: [],
                        logistics_company_id: "",
                        start_id: "",
                        end_id: "",
                    };
                    this.codeValue = "";
                    this.inputMethod = "1";
                    this.$Message.success(res.msg);
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        handleInputChange(e) {
            // 获取当前输入框的值
            const inputValue = e.target ? e.target.value : e;
            // 按换行符分割为数组（处理多行输入）
            const lines = inputValue.split("\n");
            // 用于存储处理后的所有码
            const allCodes = [];
            // 同时匹配 ?q=xxx 和 #xxx 两种链接
            const urlPattern = /https?:\/\/[^\s]+?(?:\?q=|#)([\w\-.]+)/g;
            // 处理每一行数据
            lines.forEach((line) => {
                // 处理行内的所有URL
                let match;
                let lastIndex = 0;
                const results = [];
                // 1. 提取行内所有URL的编码
                while ((match = urlPattern.exec(line)) !== null) {
                    // 添加URL前可能存在的非URL文本
                    if (match.index > lastIndex) {
                        const textBefore = line
                            .substring(lastIndex, match.index)
                            .trim();
                        if (textBefore) results.push(textBefore);
                    }
                    // 添加提取到的编码（两种分隔符捕获结果都存在 match[1]）
                    results.push(match[1]);
                    // 更新lastIndex
                    lastIndex = match.index + match[0].length;
                }
                // 2. 添加最后一个URL后的剩余文本
                if (lastIndex < line.length) {
                    const textAfter = line.substring(lastIndex).trim();
                    if (textAfter) results.push(textAfter);
                }
                // 3. 处理没有URL的直接输入码
                if (results.length === 0) {
                    const directCodeMatch = line.match(/^([\w\-.]+)\s*$/);
                    if (directCodeMatch) {
                        results.push(directCodeMatch[1]);
                    } else {
                        results.push(line); // 保留原始行内容
                    }
                }
                // 收集当前行的所有结果
                allCodes.push(...results);
            });
            // 更新v-model绑定的数据（去除空行）
            this.codeValue = allCodes
                .filter((code) => code.trim() !== "")
                .join("\n");
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    margin-bottom: 24px;
    padding: 24px;
    background: rgba(255, 118, 29, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
}
.w24 {
    width: 24px;
    height: 24px;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    position: relative;
}
.footer {
    margin: 24px 0 0 0;
    padding: 24px 0 0 0;
    text-align: center;
    border-top: 1px solid #eee;
}
.w400 {
    width: 400px;
}
.w10 {
    width: 10vw;
}
.cursor-p {
    cursor: pointer;
}
::v-deep
    .ivu-radio-group
    .ivu-radio-wrapper-checked
    .ivu-radio-checked
    .ivu-radio-inner {
    border: 2px solid #ff761d;
}
::v-deep
    .ivu-radio-group
    .ivu-radio-wrapper-checked
    .ivu-radio-checked
    .ivu-radio-inner:after {
    background-color: #fff;
}
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #53c41a;
    border-color: #53c41a;
    box-shadow: -1px 0 0 0 #53c41a;
    border-radius: 5px;
    color: #fff;
    z-index: 1;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
</style>